import styled from 'styled-components';

export const Board = styled.div<{ boardHeight?: number }>`
  height: ${(props) => (props.boardHeight ? `${props.boardHeight}px` : 'auto')};
  align-items: stretch;
`;

export const Column = styled.div<{ barColor: string }>`
  width: 300px;
  min-width: 300px;
  border: 1px solid ${(props) => props.theme.$gray300};
  border-top: 3px solid ${(props) => props.barColor};

  .column-empty {
    min-height: 64px;
    border: 1px dashed ${(props) => props.theme.$gray400};
  }
`;
